import { chordName } from '@/lib/droneChords';

const Big = ({ testid, caption, text, dim }) => (
  <div className="flex flex-col items-start min-w-0">
    <span className="text-[10px] uppercase tracking-[0.3em] text-white/40">{caption}</span>
    <span data-testid={testid} className={`font-mono font-bold leading-none mt-2 truncate max-w-full ${dim ? 'text-4xl sm:text-6xl text-white/35' : 'text-6xl sm:text-8xl text-sky-300 drop-shadow-[0_0_24px_rgba(56,189,248,0.35)]'}`}>{text}</span>
  </div>
);

// Large "now / next" readout for the drone page.
export const DroneNowNext = ({ drone }) => {
  const { active, label, progOn, prog, stepIdx, barCount, voicing, flats } = drone;
  const steps = prog.steps;
  const next = progOn ? steps[(stepIdx + 1) % steps.length] : null;
  const nextText = next && (voicing === 'chord' ? chordName(next.pc, next.quality, flats) : chordName(next.pc, 'maj', flats));
  let barInStep = 0;
  if (progOn && barCount > 0) {
    const total = steps.reduce((s, st) => s + st.bars, 0);
    let pos = (barCount - 1) % total;
    for (let i = 0; i < stepIdx; i++) pos -= steps[i].bars;
    barInStep = pos + 1;
  }
  return (
    <section data-testid="drone-now-next" className={`bg-[#111112] border rounded-2xl px-5 py-6 sm:px-8 sm:py-10 flex items-end justify-between gap-6 ${active ? 'border-sky-400/40' : 'border-white/5'}`}>
      <Big testid="drone-now" caption={active ? 'Suona ora' : 'Bordone fermo'} text={label} dim={!active} />
      {progOn && (
        <div className="flex flex-col items-end gap-3 min-w-0">
          <Big testid="drone-next" caption="Prossimo" text={nextText} dim />
          <div className="flex gap-1" data-testid="drone-step-bars">
            {Array.from({ length: steps[stepIdx].bars }, (_, i) => (
              <span key={i} className={`w-2.5 h-2.5 rounded-full transition-colors ${i < barInStep ? 'bg-sky-400' : 'bg-white/10'}`} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
